<div class="flex flex-col h-full pr-2 overflow-visible pb-3">
  <!-- Logo Header -->
  <div class="mt-17 lg:mt-0">
    <app-card>
      <div class="flex items-center font-bold text-xl lg:text-2xl gap-2 md:gap-3">
        <img src="logo.svg" alt="logo" class="h-10 md:h-14" />
        <span>Kanban Flow</span>
      </div>
    </app-card>
  </div>

  <!-- Projects Section -->
  <div class="mt-6 md:mt-10 flex flex-col gap-2 md:gap-3 flex-1 mb-2">
    <!-- Projects Header -->
    <app-card>
      <div class="flex items-center justify-between">
        <span class="text-xl md:text-2xl font-bold">Projects</span>
        @if (isLoggedIn()) {
          <app-button
            variant="accent"
            size="md"
            icon="heroPlus"
            [iconOnly]="true"
            (clicked)="addProject()"
          />
        }
      </div>
    </app-card>

    <!-- Add Project Form -->
    @if (isAddingProject()) {
      <app-card>
        <div class="flex flex-col gap-2">
          <input
            type="text"
            placeholder="Project title"
            class="w-full resize-none p-2 md:p-3 border-2 border-secondary rounded-sm text-sm md:text-base"
            [(ngModel)]="newProjectTitle"
            (keydown.enter)="handleAddProject()"
            (keydown.escape)="cancelAddProject()"
            autofocus
          />

          <div class="flex items-center gap-2 md:gap-3 mt-2">
            <button
              class="w-full bg-accent border-2 border-secondary rounded-sm shadow-[3px_3px_0_0_var(--color-secondary)] py-2 text-sm md:text-base hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[2px_2px_0_0_var(--color-secondary)] transition-all cursor-pointer"
              (click)="handleAddProject()"
            >
              Add Project
            </button>
            <div
              class="rounded-full w-10 h-10 md:w-11 md:h-10 bg-scarlet-rush flex items-center justify-center cursor-pointer shrink-0"
              (click)="cancelAddProject()"
            >
              <ng-icon name="heroXMark" size="1.25rem" class="md:text-2xl" color="white"></ng-icon>
            </div>
          </div>
        </div>
      </app-card>
    }

    <!-- Projects List -->
    @for (project of projects(); track project.id) {
      <app-project-item
        [title]="project.title"
        [isSelected]="isProjectSelected(project.id)"
        (projectClicked)="selectProject(project.id)"
      />
    }
  </div>

  <!-- Bottom Section -->
  <div class="mt-auto flex flex-col gap-2 md:gap-3">
    <!-- User Profile / Login -->
    @if (isLoggedIn() && currentUser(); as user) {
      <app-user-profile
        [displayName]="user.displayName || 'User'"
        [email]="user.email"
        [photoURL]="user.photoURL || 'profile-pic-demo.jpg'"
        (logout)="handleLogout()"
      />
    } @else {
      <app-login-button (login)="handleLogin()" />
    }
  </div>
</div>
